module.exports = __webpack_public_path__ + "img/airSample.c3d87558.png";